import BaseService from "./BaseService";
import IUserResponse from "../core/contracts/IUserResponse";
import IUserResponseDTO from "../core/contracts/IUserResponseDTO";
import IResetPassword from "../core/contracts/IResetPassword";
import IPushUserToken from "../core/contracts/IPushUserToken";
import { SessionCache } from "../helpers/cache";

export default class UserService extends BaseService {
  async fetch(): Promise<IUserResponse> {
    try {
      const cache = new SessionCache();
      const response = await new BaseService(true).get<IUserResponse>("/core/user");
      cache.set("user", response);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetch -> error", error);
      return Promise.reject(error);
    }
  }

  async fetchById(id: number): Promise<IUserResponse> {
    try {
      const response = await new BaseService(true).get<IUserResponse>(`/core/user/${id}`);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetch -> error", error);
      return Promise.reject(error);
    }
  }

  async fetchAllNonAdminUsers(): Promise<IUserResponseDTO> {
    try {
      const response = await new BaseService(true).get<IUserResponseDTO>(
        "/core/User/GetAllNamesAndEmailsNonAdmins"
      );
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetchAll -> error", error);
      return Promise.reject(error);
    }
  }

  async fetchAll(): Promise<IUserResponseDTO> {
    try {
      const response = await new BaseService(true).get<IUserResponseDTO>(
        "/core/User/GetAllNamesAndEmails"
      );
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetchAll -> error", error);
      return Promise.reject(error);
    }
  }

  async resetPassword(mail: IResetPassword): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, IResetPassword>(
        "/core/User/resetpassword",
        mail
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> resetPassword -> error", error);
      return Promise.reject(error);
    }
  }

  async sendResetPassword(mail: string): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, { email: string }>(
        "/core/User/resetpassword",
        { email: mail }
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> resetPassword -> error", error);
      return Promise.reject(error);
    }
  }

  async validateResetToken(token: string): Promise<IUserResponse> {
    try {
      return await new BaseService(true).get<IUserResponse>("/core/User/resettoken/" + token);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> validateResetToken -> error", error);
      return Promise.reject(error);
    }
  }

  async updatePushToken(pushUserToken: IPushUserToken): Promise<boolean> {
    try {
      return await new BaseService(true, false, false).post<boolean, IPushUserToken>(
        "/core/User/updatePushUser",
        pushUserToken
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> updatePushUser -> error", error);
      return Promise.reject(error);
    }
  }
}
